import React, {useState} from 'react';
import {Button, Upload} from "antd";
import {toast} from "react-toastify";
import {GetApiUrl} from "@/constants/config";
import {myAcademySlug} from "@/lib/services/academyService";
import {getAuthToken} from "@/lib/services/instance";
import Dragger from "antd/es/upload/Dragger";
import {LoadingOutlined, PlusOutlined} from "@ant-design/icons";
import RenderIf from "@/components/render-if";
import RenderLoading from "@/components/render-if-loading";

export function UploadUrl() {
    return `${GetApiUrl()}/file/upload`
}

function UploadCMP({afterUploadFn, label, dragMode = false, children, model = '', accept = '*/*'}) {

    const [loading, setLoading] = useState();
    const [file, setFile] = useState()


    const filesProps = {
        name: 'file',
        multiple: false,
        showUploadList: false,
        headers: {
            Authorization: getAuthToken(),
            'X-Academy': myAcademySlug()
        },
        action: UploadUrl(), data: {}, onChange(info) {
            const {status} = info.file;
            if (status !== 'uploading') {

            }
            if (status === 'done') {
                setFile(info?.file?.response?.data)
                afterUploadFn(info);

            } else if (status === 'error') {
                toast.error('Error');
            }
        }, onDrop(e) {


        },
    };

    let uploadButton = (<button style={{border: 0, background: 'none'}} type="button">
        {loading ? <i className="icon-loader"></i> : <i className="icon-plus"></i>}
        <div className="mt-2">{'بارگذاری فایل'}</div>
    </button>);

    const getBase64 = (img, callback) => {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    };

    const beforeUpload = () => {
        return true;
    };

    const handleChange = (info) => {
        setLoading(true);
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, (url) => {
                setLoading(false);
            });
            setFile(info?.file?.response?.data)
            afterUploadFn?.(info);

            return;
        }
        toast.error("Error loading image!");
        setLoading(false);
    };

    if (model === 'avatar') {
        uploadButton = (
            <button style={{border: 0, background: 'none'}} type="button">
                {loading ? <LoadingOutlined/> : <PlusOutlined/>}
                <div style={{marginTop: 8}}>Upload</div>
            </button>
        );

        return (<Upload
            name="file"
            listType="picture-circle"
            className="avatar-uploader"
            accept={accept}
            showUploadList={false}
            action={UploadUrl()}
            headers={{
                Authorization: getAuthToken(),
                'X-Academy': myAcademySlug()
            }}
            method="post"
            beforeUpload={beforeUpload}
            onChange={handleChange}
        >
            <RenderLoading loading={loading} spin={true}/>
            {file?.url ? <img src={file?.url} alt="avatar" style={{width: '100%'}}/> : children ?? uploadButton}
        </Upload>)
    }

    return (
        <>
            <RenderLoading loading={loading} spin={true}/>

            {label && <div>{label}</div>}

            {!dragMode && <Upload
                name="file"
                listType="picture-card"
                className="avatar-uploader bg-whitse  z-20 rounded-lg "
                // previewFile={previewImage}
                // style={{width: '300px'}}
                accept={accept}
                showUploadList={false}
                headers={{
                    Authorization: getAuthToken(),
                    'X-Academy': myAcademySlug()
                }}
                action={UploadUrl()}
                method="post"
                beforeUpload={beforeUpload}
                onChange={handleChange}
            >

                {file?.url ?
                    <div className={"relative"}>
                        <Button
                            size="small"
                            className={"absolute top-1 left-1 border border-solid rounded hover:bg-blue-700"}
                            icon={<i className={`icon-pen text-xs`}/>}
                        />
                        <img src={file?.url} alt="avatar" className="rounded w-40"/>
                    </div> : uploadButton}
                {children}
            </Upload>}

            {dragMode && (<Dragger accept={accept} {...filesProps} className="flex flex-col h-32">
                    <RenderIf condition={!children}>
                        {file?.url ?
                            <div className={"relative"}>
                                <Button
                                    size="small"
                                    className={"absolute top-1 left-1 border border-solid rounded hover:bg-blue-700"}
                                    icon={<i className={`icon-pen text-xs`}/>}
                                />
                                <img src={file?.url} alt="avatar" className="rounded w-20"/>
                            </div> : <>
                                <p className="ant-upload-drag-icon">
                                    <i className="icon-cloud-arrow-up text-blue-6 text-2xl"></i>
                                </p>
                                <p className="ant-upload-text">{'بارگذاری فایل'}</p>
                            </>}
                    </RenderIf>

                    {children}
                </Dragger>
            )}

        </>
    );
}

export default UploadCMP;